
  import { computed, defineComponent, toRef, Ref } from 'vue';
  import { Button } from '@/ui/components/Button';
  import { Icon } from '@/ui/components/icon/Icon';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { EventBus } from '@/ui/EventBus';
  import { Events } from '@/ui/events';

  interface BulkDeleteButtonProps {
    resources: [];
    disabled?: boolean;
  }

  export default defineComponent<BulkDeleteButtonProps>({
    components: {
      Button,
      Icon,
      Tooltip,
    },
    props: ['resources', 'disabled'],
    setup(props) {
      const resources: Ref<[]> = toRef(props, 'resources');
      const disabled: Ref<boolean | undefined> = toRef(props, 'disabled');

      const isDisabled = computed(() => disabled.value
        ? disabled.value || resources.value.length < 1
        : resources.value.length < 1);

      const onBulkDelete = () => {
        EventBus.$emit(Events.bulkDeleteClick);
      };

      return {
        isDisabled,
        resourcesList: resources,
        onBulkDelete,
      };
    },
  });
